import PaymentMethodMixin from './PaymentMethodMixin'

export default {
    mixins: [
        PaymentMethodMixin
    ]
}